import axios from '../api/axiosInstance';

export const fetchDeliverySettlements = (params = {}) => {
  return axios.get('/delivery-settlements', { params });
};

export const fetchDeliverySettlement = (id) => {
  return axios.get(`/delivery-settlements/${id}`);
};

export const fetchPendingDeliveryCollections = (params = {}) => {
  return axios.get('/delivery-settlements/pending', { params });
};

export const createDeliverySettlement = (data) => {
  return axios.post('/delivery-settlements', data);
};

export const updateDeliverySettlement = (id, data) => {
  return axios.put(`/delivery-settlements/${id}`, data);
};

